import { useTranslation } from 'react-i18next';
import { FieldItem } from '@lib/interfaces/form';
import TaskCompletionsFilterFieldNames from '@lib/enums/fieldNames/taskCompletionsFilterFieldNames';
import { getOptionsArrayValidation } from '@lib/utils/validationUtils';
import Select, {
  SelectComponents,
  SelectProps,
} from '@lib/components/Select/Select';
import getValidityHintOptions from 'components/FormTemplateBuilder/utils/getValidityHintOptions';
import MultiSelectValueContainer from '@lib/components/Select/components/MultiSelectValueContainer';
import UserOption from '@lib/components/Select/components/UserOption';
import { GetLoadOptions } from '@lib/components/Select/types';

export const TASK_REPORTING_FILTER_DEFAULT_VALUES = {
  [TaskCompletionsFilterFieldNames.Period]: [],
  [TaskCompletionsFilterFieldNames.Users]: [],
  [TaskCompletionsFilterFieldNames.ValidityHints]: [],
};

export default function useTaskReportingFilterFields({
  getUsersLoadOptions,
}: {
  getUsersLoadOptions: GetLoadOptions;
}): FieldItem[] {
  const { t } = useTranslation();

  return [
    {
      name: TaskCompletionsFilterFieldNames.Users,
      label: t('performers-label'),
      element: Select,
      validation: getOptionsArrayValidation({ t }),
      componentProps: {
        isAsync: true,
        isMulti: true,
        getLoadOptions: getUsersLoadOptions,
        defaultOptions: false,
        components: {
          Option: UserOption,
          ValueContainer: MultiSelectValueContainer,
        } as unknown as SelectComponents,
        disabledTooltipProps: {
          body: t('choose-site-first'),
        },
        usePortal: true,
      } as SelectProps,
      isOptionalFn: () => false,
    },
    {
      name: TaskCompletionsFilterFieldNames.ValidityHints,
      label: t('completion-statuses-label'),
      element: Select,
      validation: getOptionsArrayValidation({ t }),
      componentProps: {
        isSearchable: false,
        isMulti: true,
        options: getValidityHintOptions(),
        menuPlacement: 'top',
        usePortal: true,
      },
      isOptionalFn: () => false,
    },
  ];
}
